import { useEffect, useRef } from 'react';
import { recordMyActivity } from '../api/userApi';

const CLIENT_ACTIVITY_INTERVAL_MS = 15 * 60 * 1000;

export function useAccountActivity(enabled) {
  const lastSentAtRef = useRef(0);

  useEffect(() => {
    if (!enabled) {
      lastSentAtRef.current = 0;
      return undefined;
    }

    const reportActivity = () => {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - lastSentAtRef.current < CLIENT_ACTIVITY_INTERVAL_MS) return;
      lastSentAtRef.current = now;
      void recordMyActivity().catch(() => {
        // Activity reporting is best-effort and must never interrupt the user.
      });
    };

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') reportActivity();
    };

    reportActivity();
    window.addEventListener('pointerdown', reportActivity, { passive: true });
    window.addEventListener('keydown', reportActivity);
    window.addEventListener('scroll', reportActivity, { capture: true, passive: true });
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      window.removeEventListener('pointerdown', reportActivity);
      window.removeEventListener('keydown', reportActivity);
      window.removeEventListener('scroll', reportActivity, true);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [enabled]);
}
